<template>
  <div>
    <b-modal
      id="publishSuccesful"
      ref="publishSuccesful"
      hide-footer
      title="Edition aktualisiert"
      no-fade
      @hide="editonPublished()"
    >
      <div class="d-block mb-4">
        Die Edition wurde erfolgreich aktualisiert.
      </div>
      <div
        v-if="tenantsForVersion"
        class="tenantInfo"
      >
        <div
          v-for="(tenantConfig, index) in tenantsForVersion.filter(
            (tenantc) => {
              return publicationAndValidAfterToday(tenantc);
            },
          )"
          :key="index"
          class="mb-2"
        >
          Edition {{ createdEdition }} wurde erfolgreich für
          {{
            availableTenants.filter((t) => {
              return t.id == tenantConfig.tenantId;
            }).length > 0
              ? availableTenants.filter((t) => {
                return t.id == tenantConfig.tenantId;
              })[0].bezeichnung
              : "den Tenant"
          }}
          publiziert
          <br>
          Publikationsdatum:
          <span v-if="tenantConfig.publicationDate">{{
            tenantConfig.publicationDate | moment("DD.MM.YYYY")
          }}</span><span v-else>--</span>
          <br>
          Gültig ab:
          <span v-if="tenantConfig.validFrom">{{
            tenantConfig.validFrom | moment("DD.MM.YYYY")
          }}</span><span v-else>--</span>
        </div>
        <h5 class="mt-4 mb-2">
          zukünftige Publikationen
        </h5>
        <div
          v-for="(tenantConfig, index) in tenantsForVersion.filter(
            (tenantc) => {
              return !publicationAndValidAfterToday(tenantc);
            },
          )"
          :key="index"
          class="mb-2"
        >
          {{
            availableTenants.filter((t) => {
              return t.id == tenantConfig.tenantId;
            }).length > 0
              ? availableTenants.filter((t) => {
                return t.id == tenantConfig.tenantId;
              })[0].bezeichnung
              : "den Tenant"
          }}
          <br>
          Publikationsdatum:
          <span v-if="tenantConfig.publicationDate">{{
            tenantConfig.publicationDate | moment("DD.MM.YYYY")
          }}</span><span v-else>--</span>
          <br>
          Gültig ab:
          <span v-if="tenantConfig.validFrom">{{
            tenantConfig.validFrom | moment("DD.MM.YYYY")
          }}</span><span v-else>--</span>
        </div>
      </div>
      <b-button
        variant="success"
        @click="hideModal('publishSuccesful')"
      >
        Ok
      </b-button>
    </b-modal>
    <button
      v-b-tooltip.hover
      v-b-modal.publishEdition
      type="button"
      placement="bottom"
      title="Edition aktualisieren"
      class="btn-success float-right w-100 h-100"
      @click="checkRequirements"
    >
      <i class="fas fa-cloud-upload-alt" />
    </button>
    <b-modal
      id="publishEdition"
      ref="publishEdition"
      hide-footer
      title="Edition aktualisieren"
      no-fade
    >
      <u-loader v-if="!checkresults || isLoading" />
      <template v-else>
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <div v-if="checkresults.checkState == 1">
          Edition enthält keine Fehler und kann aktualisiert werden.
        </div>
        <template
          v-if="
            checkresults.issues.filter((issue) => {
              return issue.issueState == 3;
            }).length > 0
          "
        >
          <b>Fehler</b>
          <ul>
            <li
              v-for="(error, index) in checkresults.issues.filter((issue) => {
                return issue.issueState == 3;
              })"
              :key="index"
            >
              {{ error.sourceObject }}: {{ error.issueDescription }}
            </li>
          </ul>
        </template>
        <template
          v-if="
            checkresults.issues.filter((issue) => {
              return issue.issueState == 2;
            }).length > 0
          "
        >
          <b>Warnungen</b>
          <ul>
            <li
              v-for="(error, index) in checkresults.issues.filter((issue) => {
                return issue.issueState == 2;
              })"
              :key="index"
            >
              {{ error.sourceObject }}: {{ error.issueDescription }}
            </li>
          </ul>
        </template>

        <i
          v-if="checkresults.checkState == 3"
          class="my-2 d-block text-danger"
        >Die Edition kann erst aktualisiert werden wenn alle Fehler behoben
          wurden.</i>

        <i
          v-if="checkresults.checkState == 2"
          class="my-2 d-block text-danger"
        >
          Bist du sicher, dass du die Edition trotz
          {{
            checkresults.issues.filter((issue) => {
              return issue.issueState == 2;
            }).length > 1
              ? "den Warnungen"
              : "der Warnung"
          }}
          dennoch publizieren willst?
        </i>

        <b-button
          v-if="checkresults.checkState == 1 || checkresults.checkState == 2"
          variant="success"
          class="mr-2"
          @click="openMLCheckStep"
        >
          Weiter
        </b-button>
        <b-button
          variant="danger"
          @click="hideModal('publishEdition')"
        >
          Abbrechen
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="EditionMlChangeCheck"
      ref="EditionMlChangeCheck"
      hide-footer
      title="Mindestlohnänderungen prüfen"
      no-fade
    >
      <u-loader v-if="!checkresults || isLoading" />
      <template v-else>
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <h5>Resultate der automatischen Prüfung:</h5>
        <template v-if="mlChanges && mlChanges.length > 0">
          <div
            v-for="(change, changeIndex) in mlChanges"
            :key="changeIndex"
          >
            <template>
              <b>{{ change.section }}</b>: {{ change.description }}
            </template>
          </div>
        </template>
        <template v-else>
          <div>
            Es wurden kein Änderungen in der Mindestlohnkonfiguration oder den
            arbeitszeit und lohnrelevante Klauseln gefunden.
          </div>
        </template>
        <br>
        <div class="row">
          <div class="col-6">
            Sind seit der letzten Publikation Mindestlohnänderungen vorgenommen
            worden?
          </div>
          <v-checkbox
            v-model="mlChanged"
            class="col-4"
            color="#e72b37"
          />
        </div>
        <br>
        <div class="row">
          <div class="col-6">
            Wurden Änderungen an arbeitszeit und/oder lohnrelevante Klauseln
            seit der letzten Publikation vorgenommen?
          </div>
          <div class="col-6">
            <v-radio-group
              v-model="klauselnChanged"
              row
              color="#e72b37"
            >
              <v-radio
                label="Ja"
                :value="true"
                color="#e72b37"
              />
              <v-radio
                label="Nein"
                :value="false"
                color="#e72b37"
              />
            </v-radio-group>
          </div>
        </div>
        <br>
        <b-button
          variant="success"
          class="mr-2"
          :disabled="klauselnChanged === null"
          @click="publishEdition()"
        >
          Ok
        </b-button>
        <b-button
          variant="danger"
          @click="hideModal('EditionMlChangeCheck')"
        >
          Abbrechen
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  PublishEdition,
  CheckPublicationRequirements,
  CheckMlChanges,
} from "@/services/contract.edition.service.js";
import {
  GetAllPublications,
  GetAvailableTenants,
} from "@/services/contract.tenants.service.js";
export default {
  props: {
    contractId: {
      type: String,
      required: true,
    },
    versionId: {
      type: Number,
      required: true,
    },
    versionIdId: {
      type: Number,
      required: true,
    },
    currentEditionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      errorObject: null,
      checkresults: null,
      isLoading: false,
      tenantsForVersion: null,
      availableTenants: null,
      createdEdition: null,
      mlChanges: [],
      mlChanged: false,
      klauselnChanged: null,
    };
  },
  created() {
    this.LoadAvailableTenants();
  },
  methods: {
    publicationAndValidAfterToday(tenantConfig) {
      if (!tenantConfig.publicationDate || !tenantConfig.validFrom) {
        return false;
      }
      var pDate = this.$moment(tenantConfig.publicationDate);
      var vDate = this.$moment(tenantConfig.validFrom);
      var nowDate = this.$moment(new Date());

      return pDate <= nowDate && vDate <= nowDate;
    },
    checkRequirements() {
      this.checkresults = null;
      CheckPublicationRequirements(
        this.contractId,
        this.versionId,
        this.currentEditionId,
        3, //Aktualisiert
        (results) => {
          this.checkresults = results;
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    LoadAvailableTenants() {
      GetAvailableTenants(
        (response) => {
          this.availableTenants = response;
        },
        () => {
          this.availableTenants = [];
        },
      );
    },
    openMLCheckStep() {
      this.hideModal("publishEdition");
      this.showModal("EditionMlChangeCheck");
      this.isLoading = true;

      CheckMlChanges(
        this.contractId,
        this.versionId,
        this.currentEditionId,
        (results) => {
          this.mlChanges = results;
          if (results.length > 0) {
            this.mlChanged = true;
          }
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    publishEdition() {
      this.errorObject = null;
      this.isLoading = true;

      PublishEdition(
        this.contractId,
        this.versionId,
        this.currentEditionId,
        this.mlChanged,
        this.klauselnChanged,
        (response) => {
          this.createdEdition = response;
          GetAllPublications(
            this.contractId,
            this.versionIdId,
            (response) => {
              this.tenantsForVersion = response;
              this.$refs["publishSuccesful"].show();
              this.hideModal("publishEdition");
              this.isLoading = false;
            },
            () => {
              this.$refs["publishSuccesful"].show();
              this.hideModal("publishEdition");
              this.isLoading = false;
            },
          );
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    editonPublished() {
      this.$emit("editionsChanged");
      this.$eventBus.$emit("editionsChanged");
    },
  },
};
</script>

<style lang="scss" scoped></style>
